import {Col, Form, Input, message, Row, Tooltip} from "antd";
import {CopyOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {getAutocodeWeighingStation} from "../../../api/weighingStation";
import DgSelectCustomer from "./select/customer";
import {DG_Format_Status} from "../../../format/Status";
import RenderInputOnChange from "../../../common/input/RenderInputOnChange";
import RenderInput from "../../../common/input/RenderInput";

const Content = ({id,form, customer, status, setStatus}) => {

    const [name, setName] = useState()
    const copyLinkCode = () => {

        let link = form?.getFieldValue("weighingStationCode") === undefined ?
            "" : form?.getFieldValue("weighingStationCode")
        navigator.clipboard.writeText(link);
        message.success("Đã sao chép thành công")
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (name) {
                getAutocodeWeighingStation(form?.getFieldValue("weighingStationName")).then((response) => {
                    form.setFieldsValue({weighingStationCode: response})
                })
                    .catch(()=>{})
            }
        }, 500)
        return () => clearTimeout(delayDebounceFn)
    }, [name, form])

    return (
        <>
            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <RenderInputOnChange form={form}
                                         name={"weighingStationName"}
                                         label={"Tên trạm cân"}
                                         placeholder={"Nhập tên trạm cân"}
                                         required={true}
                                         message={"Tên trạm cân là trường bắt buộc"}
                                         onChange={(value) => {
                                             if (id === undefined)
                                                 setName(value);
                                         }}/>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Mã trạm cân"}
                        name="weighingStationCode"
                    >
                        <Input disabled={true}
                               addonAfter={<>
                                   <Tooltip title="Sao chép mã khách hàng">
                                       <CopyOutlined onClick={copyLinkCode} style={{color: "black"}}/>
                                   </Tooltip>
                               </>}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <RenderInput form={form}
                                 name={"address"}
                                 label={"Địa chỉ"}
                                 required={false}
                                 placeholder={"Nhập địa chỉ"} />
                </Col>
            </Row>

            {
                customer && <Row gutter={12}>
                    <Col
                        xxl={{span: 24}}
                        xl={{span: 24}}
                        lg={{span: 24}}
                    >
                        <Form.Item
                            label={"Khách hàng"}
                            name="customerId"
                        >
                            <DgSelectCustomer form={form} />
                        </Form.Item>
                    </Col>
                </Row>
            }

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Trạng thái"}
                        valuePropName="checked"
                        initialValue={true}
                    >
                        {DG_Format_Status(status)}
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

export default Content
